import { graphql } from "babel-plugin-relay/macro";

export const mutation = graphql`
    mutation createCsvMutation($input: CreateCsvInput!) {
        createCsv(input: $input) {
            presignedGetUrl
        }
    }
`;
